import { LorawanStation, StationLocation, StationLoRaWANCreate } from 'models/base-station';

export const LORAWAN_BASE_STATION_LOCATION_CREATE = 'LORAWAN_BASE_STATION_LOCATION_CREATE';
export const LORAWAN_BASE_STATION_LOCATION_ATTACH = 'LORAWAN_BASE_STATION_LOCATION_ATTACH';
export const LORAWAN_BASE_STATION_LOCATION_DETACH = 'LORAWAN_BASE_STATION_LOCATION_DETACH';

export interface AttachLoraStationLocation {
  readonly type: typeof LORAWAN_BASE_STATION_LOCATION_ATTACH;
  station: LorawanStation;
  location: StationLocation;
}

export interface CreateStationLorawan {
  readonly type: typeof LORAWAN_BASE_STATION_LOCATION_CREATE;
  readonly params: StationLoRaWANCreate;
}

export interface DetachLorawanStationLocation {
  readonly type: typeof LORAWAN_BASE_STATION_LOCATION_DETACH;
  station: LorawanStation;
}

export const AttachLoraStationLocation = (station: LorawanStation, location: StationLocation): AttachLoraStationLocation => ({
  type: LORAWAN_BASE_STATION_LOCATION_ATTACH, station, location
});

export const CreateStationLorawan = (params: StationLoRaWANCreate): CreateStationLorawan => ({
  type: LORAWAN_BASE_STATION_LOCATION_CREATE, params
});

export const DetachLorawanStationLocation = (station: LorawanStation): DetachLorawanStationLocation => ({
  type: LORAWAN_BASE_STATION_LOCATION_DETACH, station
});

export type Action =
  | AttachLoraStationLocation
  | CreateStationLorawan
  | DetachLorawanStationLocation